<template>
  <el-table :data="currentValue" style="width: 100%">
    <el-table-column :label="$t('orderLine.ticketNumber')" width="180">
      <template slot-scope="scope">
        <span>{{ scope.row['orderNumber'] }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.halfPanelTo')" width="250">
      <template slot-scope="scope">
        <span>{{ scope.row['halfPanelTo'] }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.halfPanelFrom')" width="250">
      <template slot-scope="scope">
        <span>{{ scope.row['halfPanelFrom'] }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.sharesHanger')" width="250">
      <template slot-scope="scope">
        <span>{{ scope.row['sharesParcel'] ? $t('common.yes') : $t('common.no') }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.embraceForOrderNumber')" width="250">
      <template slot-scope="scope">
        <span>{{ scope.row['tieBackFor'] }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.embraceFromOrderNumber')" width="250">
      <template slot-scope="scope">
        <span>{{ scope.row['tieBackFrom'] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    value: Array
  },
  data: () => ({
    currentValue: []
  }),
  watch: {
    value(value) {
      this.currentValue = value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
